import { render, staticRenderFns } from "./MappedColumnMapper.vue?vue&type=template&id=0d1f1130&"
import script from "./MappedColumnMapper.vue?vue&type=script&lang=js&"
export * from "./MappedColumnMapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports